import { useContext, useEffect, useState } from "react"
import { useTranslation } from 'react-i18next';
import { NotificationContext } from "shared/NotificationContext"
import { NotificationType, PublicLead } from "shared/topchef.types"
import { useBackofficeApi } from 'shared/useBackofficeApi';
import Loading from "pages/shared/loading/Loading"

import MoreDetailsCellRenderer from "pages/shared/more-details-renderer/MoreDetailsCellRenderer"
import BackofficeBriefsMarketMenu from "../backoffice-briefs-market-menu/BackofficeBriefsMarketMenu"
import BriefsList from "pages/shared/briefs-list/BriefsList"
import { useErrorBoundary } from "react-error-boundary";

const BackofficeLeadsToValidate = () => {

  const { t } = useTranslation();
  const [leadsLoaded, setLeadsLoaded] = useState<boolean>(false);
  const [leadsToValidate, setLeadsToValidate] = useState<PublicLead[]>([]);
  
  const notificationContext = useContext(NotificationContext);
  const { triggerNotification } = notificationContext;

  const { showBoundary } = useErrorBoundary();
  const backofficeApi = useBackofficeApi();

  useEffect(() => {
    setLeadsLoaded(false);
  }, [backofficeApi.country]);

  useEffect(() => { // eslint-disable-line react-hooks/exhaustive-deps

    async function loadLeadsToValidate() {
      try {
        const leads: PublicLead[] = await backofficeApi.loadLeadsToValidate();
        setLeadsToValidate(leads);
        setLeadsLoaded(true);
      } catch (error: any) { 
        const newError = new Error(t('apiErrors.loadLeadsToValidate', { details: error.message }) as string);
        triggerNotification({type: NotificationType.error, message : newError.message});
        showBoundary(newError);
      } 
    }

    if (leadsLoaded) {
      return;
    }
    loadLeadsToValidate();

  }, [leadsLoaded, backofficeApi, triggerNotification, showBoundary]); // eslint-disable-line react-hooks/exhaustive-deps


  const moreDetailsRenderer = (params: any) => {
    const leadId: string = params.data.id;
    return (
      <MoreDetailsCellRenderer url={`/backoffice/leads/to-validate/${leadId}`} label={t('actionLabels.validate')}  />
    );
  };


  if (!leadsLoaded) {
    return (
      <Loading />
    );
  }

  return (

     <div className="container p-5 overflow-auto backoffice-leads-to-validate">

      <h5 className="mb-3">{t('nav.briefsToValidate')}</h5>

      <BackofficeBriefsMarketMenu />

      <BriefsList leads={leadsToValidate} height='80%' paginateResults={true} detailsRenderer={moreDetailsRenderer} />

    </div>
  );

}

export default BackofficeLeadsToValidate;
